module.exports = __webpack_public_path__ + "img/main.dbcff6b.webp";